import { createSlice } from '@reduxjs/toolkit';
import { api } from '../../services';
import {
    handelResponse,
    handelCatch,
} from '../slices';

const initialState = {
    aiAbstractData: {}
};
const aiAbstractSubmissionSlice = createSlice({
    name: 'aiAbstractSubmission',
    initialState,
    reducers: {
        storeAiAbstractData(state, action) {
            state.aiAbstractData = action.payload;
        },
    },
});

export const uploadPaperSubmission = (formData) => async (dispatch) => {
    try {
        const res = await api.post('/user/event/submit-ai-abstract-file', formData);
        return await dispatch(handelResponse(res));
    } catch (error) {
        return dispatch(handelCatch(error));
    }
};

export const fetchAiAbstractData = (queryParams) => async (dispatch) => {
    try {
        const res = await api.get(`/user/event/get-ai-abstract-data?id=${queryParams}&submitted_from=dashboard`);
        const response = await dispatch(handelResponse(res));
        dispatch(storeAiAbstractData(response?.data || {}));
        return response;
    } catch (error) {
        return dispatch(handelCatch(error));
    }
};


export const fetchCurrentPaper = (formData) => async (dispatch) => {
    try {
        const res = await api.post('/user/event/get-current-paper', formData);
        return await dispatch(handelResponse(res));
    } catch (error) {
        return dispatch(handelCatch(error));
    }
};


export const addAiSubmitAbstract = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/event/submit-ai-abstract', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};


export const addAiAbstractStepData = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/event/store-ai-abstract-data', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const removeAiSubmitAbstract = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/event/delete-ai-paper', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};


export const {
    storeAiAbstractData
} = aiAbstractSubmissionSlice.actions;
export default aiAbstractSubmissionSlice.reducer;
